import { render, staticRenderFns } from "./upsell-update.vue?vue&type=template&id=7cc70372&scoped=true"
import script from "./upsell-update.vue?vue&type=script&lang=js"
export * from "./upsell-update.vue?vue&type=script&lang=js"
import style0 from "./upsell-update.vue?vue&type=style&index=0&id=7cc70372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc70372",
  null
  
)

export default component.exports